/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Phonenumber2Inputs */

const en_formfields_phonenumber2 = /** @type {(inputs: Formfields_Phonenumber2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone number`)
};

/**
* | output |
* | --- |
* | "Phone number" |
*
* @param {Formfields_Phonenumber2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_phonenumber2 = /** @type {((inputs?: Formfields_Phonenumber2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Phonenumber2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_phonenumber2(inputs)
});
export { formfields_phonenumber2 as "formFields_phoneNumber" }